import { useMemo } from "react";
import { router } from "react-query-kit";
import { Parameter } from "@services/api/parameters/parameters.types";
import {
  getPagedRequest,
  getRequest,
  QueryParams,
  saveRequest,
  useBaseUrl,
  useInvalidate
} from "@services/api/requests.service";
import { ParameterFormData } from "@src/app/parameters/ParameterForm";

export type ParameterValueType = boolean | string[] | string;

export interface ParameterMap {
  [key: string]: ParameterValueType;
  languages: string[];
}

export default function useParameterApi() {
  const baseUrl = useBaseUrl("/parameters");

  const parametersApi = useMemo(
    () =>
      router("parameters", {
        get: router.query({
          fetcher: (queryParams: QueryParams) =>
            getRequest<Parameter[]>(baseUrl, queryParams)
        }),
        page: router.query({
          fetcher: (queryParams: QueryParams) =>
            getPagedRequest<Parameter>(baseUrl, queryParams)
        }),
        upsert: router.mutation({
          mutationFn: (data: ParameterFormData) =>
            saveRequest<Parameter>(baseUrl, data)
        })
      }),
    [baseUrl]
  );

  const invalidate = useInvalidate(parametersApi);

  return {
    useGetQuery: parametersApi.get.useQuery,
    usePageQuery: parametersApi.page.useQuery,
    useSaveMutation: parametersApi.upsert.useMutation,
    invalidate
  };
}
